import PageHeader from "../core/App/PageHeader";
import PagePanel from "../core/App/PagePanel";
import { LoadingSpinner } from "../core/components/LoadingSpinner";
import { useMeQuery, UserRole } from 'legoland-sdk/dist/experimental';
import { useState } from 'react';
import { Button, Heading, HGrid } from 'tombac';
import { ChevronSDownIcon, ChevronSUpIcon } from 'tombac-icons';
import { InvitationalModalWrapper } from "./components/OrganizationInvitationModalWrapper";
import { TransferContextProvider } from "./components/OrganizationTransferContext";
import OrganizationTree from "./components/OrganizationTree";
import OrganizationTreeProvider from "./components/OrganizationTreeContext";
import { useOrgTree } from "./hooks/useOrgs";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OrganizationsPage = () => {
  const {
    data: {
      me
    }
  } = useMeQuery();
  const [tree, updateTree] = useOrgTree();
  const [treeCommand, setTreeCommand] = useState();
  return /*#__PURE__*/_jsxs("div", {
    "data-sentry-component": "OrganizationsPage",
    "data-sentry-source-file": "OrganizationsPage.tsx",
    children: [/*#__PURE__*/_jsx(PageHeader, {
      transparent: true,
      "data-sentry-element": "PageHeader",
      "data-sentry-source-file": "OrganizationsPage.tsx",
      "data-sentry-element": "PageHeader",
      children: /*#__PURE__*/_jsx(Heading, {
        as: "h1",
        level: 3,
        $mb: "0sp",
        "data-sentry-element": "Heading",
        "data-sentry-source-file": "OrganizationsPage.tsx",
        "data-sentry-element": "Heading",
        children: "Organizations"
      })
    }), /*#__PURE__*/_jsxs(PagePanel, {
      "data-sentry-element": "PagePanel",
      "data-sentry-source-file": "OrganizationsPage.tsx",
      "data-sentry-element": "PagePanel",
      children: [me.role === UserRole.Admin && /*#__PURE__*/_jsxs(HGrid, {
        className: "OrganizationsPage__toolbar",
        justifyContent: "flex-end",
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: () => setTreeCommand({
            type: 'expand'
          }),
          prepend: /*#__PURE__*/_jsx(ChevronSDownIcon, {}),
          size: "s",
          children: "Expand"
        }), ' ', /*#__PURE__*/_jsx(Button, {
          onClick: () => setTreeCommand({
            type: 'collapse'
          }),
          prepend: /*#__PURE__*/_jsx(ChevronSUpIcon, {}),
          size: "s",
          children: "Collapse"
        })]
      }), !tree ? /*#__PURE__*/_jsx(LoadingSpinner, {}) : /*#__PURE__*/_jsxs(TransferContextProvider, {
        children: [/*#__PURE__*/_jsx(InvitationalModalWrapper, {}), /*#__PURE__*/_jsx(OrganizationTreeProvider, {
          tree: tree,
          children: /*#__PURE__*/_jsx(OrganizationTree, {
            onChange: updateTree,
            treeBranch: tree,
            treeCommand: treeCommand
          })
        })]
      })]
    })]
  });
};